import React, { memo } from 'react';
import {
  IPopoverToModalProps,
  ITopToolbarProps,
  PopoverToModal,
  SearchTextField,
  SearchTextFieldProps,
} from '~/Components';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  content: {
    padding: '0 15px',
  },
  searchContainer: {
    margin: '0 -15px',
  },
}));

interface IModalSelectPopover extends IPopoverToModalProps, ITopToolbarProps {
  info?: React.ReactNode;
  search: Omit<SearchTextFieldProps, 'onChange'> & {
    value: string | number;
    handleSearch: SearchTextFieldProps['onChange'];
  };
}

export const ModalSelectPopover = memo(
  ({
    open,
    info,
    title,
    search,
    onClose,
    anchorEl,
    actionName,
    children: list,
    onActionTaken,
  }: IModalSelectPopover) => {
    const { classes } = useStyles();

    return (
      <PopoverToModal
        open={open}
        title={title}
        onClose={onClose}
        anchorEl={anchorEl}
        actionName={actionName}
        onActionTaken={onActionTaken}
      >
        <div className={classes.content}>
          {info}
          <div className={classes.searchContainer}>
            <SearchTextField
              id={search.id}
              value={search.value}
              onChange={search.handleSearch}
              placeholder={search.placeholder}
              withBackground
            />
          </div>
          {list}
        </div>
      </PopoverToModal>
    );
  },
);
